<div [ngClass]="{ 
      'cabecalho-placa' : cabecalho?.placa && !placaMercosul,
      'cabecalho-placa-sem' : !cabecalho?.placa,
      'cabecalho-placa-mercosul' : placaMercosul && cabecalho?.placa
    }">
    <div>{{ emplacamento || '' }}</div>
  <div *ngIf="cabecalho?.placa" [ngClass]="{ 'cabecalho-uf-Municipio' : !cabecalho?.uf && !cabecalho?.municipio }" >{{ cabecalho?.placa }}</div>
</div>